import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NursePractitioner, AssignNursePractitioner } from '../model/np-data';
import { NpPageRequest } from '../model/nppage-request';


@Injectable({
  providedIn: 'root'
})
export class NursePractitionerService {

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public getNursePractitioner(request: NpPageRequest): Observable<any> {
    console.log("Get all NursePractitioner list..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<NursePractitioner>(this.baseUrl.concat("/nurse-practitioners"), request, {headers: headers});
  }

  public getNPByProjectId(projectIds: string[]): Observable<any> {
    console.log("Get NursePractitioner by projectIds.."+projectIds);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/nurse-practitioners/projects/"), projectIds, {headers: headers});
  }

  public assignNPs(nursePractitioner: AssignNursePractitioner) {
    console.log("assigning new NursePractitioner.."+nursePractitioner);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/nurse-practitioners/assign")
      , nursePractitioner, { headers: headers });
  }

  public getAllNursePractitioner(): Observable<any> {
    console.log("Get all NursePractitioner List ..");
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<any>(this.baseUrl.concat("/nurse-practitioners/all"), { headers: headers });
  }

}
